import Marquee from "react-fast-marquee";

const ITEMS = [
  "We're mobile & come to you!",
  "Your home",
  "Your work",
  "Your place of business",
  "We come to you — saving you time & hassle!",
];

export const MobileMarquee = () => {
  return (
    <section id="mobile" data-testid="mobile-banner" className="bg-brand-red py-6 md:py-8 border-y-2 border-black/20">
      <Marquee speed={55} gradient={false} autoFill pauseOnHover>
        {ITEMS.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic font-extrabold uppercase tracking-tight text-white text-3xl md:text-5xl px-6 md:px-10">
              {t}
            </span>
            <span className="text-white/60 text-2xl md:text-4xl">•</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
